import { ArticlesResponse } from "../../data/models/article";
import axios from "axios";

const ArticlesRepository = () => {
  const getArticles = async (page = 1): Promise<ArticlesResponse> => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_STRAPI_URL}/api/articles?populate=*&pagination[page]=${page}&pagination[pageSize]=10`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_STRAPI_API_TOKEN}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  const getArticle = async (id: string): Promise<ArticlesResponse> => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_STRAPI_URL}/api/articles?filters[slug]=${id}&populate=*`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_STRAPI_API_TOKEN}`,
            "Access-Control-Allow-Origin": "*",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  const loadMoreArticles = async (
    page = 1,
    currentCount = 0,
  ): Promise<ArticlesResponse> => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_STRAPI_URL}/api/articles?populate=*&pagination[page]=${page}&pagination[pageSize]=${currentCount + 10}`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_STRAPI_API_TOKEN}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  return {
    getArticles,
    loadMoreArticles,
    getArticle,
  };
};
export default ArticlesRepository;
